module.exports = __webpack_public_path__ + "assets/img/wooden-shield.af5199c1.png";